import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "src/app/services/common.service";
import { EmployeeService } from "../employee.service";
import { BsModalRef } from "ngx-bootstrap";

@Component({
  selector: "app-employee-form",
  templateUrl: "./employee-form.component.html",
  styleUrls: ["./employee-form.component.sass"],
})
export class EmployeeFormComponent implements OnInit {
  isAuthorized = sessionStorage.getItem("ivu");
  isLoading = false;

  category = "";
  categories = [];
  isValid = false;
  submitted = false;
  inventoryId = "";
  addInventoryForm: FormGroup;

  initialData = {
    _id: "",
    name: "",
    address: "",
    phoneNumber: null,
    email: "",
    position: "",
    roleDescription: "",
    hourlyRate: null,
    commissionPercentage: "",
    customerExperienceBonus: "",
    overnightAllowance: "",
    targetOncentives: "",
    verbalWarnings: "",
    writtenWarnings: "",
    employeeNo: "",
    startDate: null,
  };

  constructor(
    private _fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private api: EmployeeService,
    private commonService: CommonService,
    private bsModalRef: BsModalRef
  ) {}

  ngOnInit() {
    this.initialData.startDate = new Date(this.initialData.startDate)
      .toISOString()
      .slice(0, 10);

    this.route.params.subscribe(() => {
      this.addInventoryForm = this._fb.group({
        name: [
          this.initialData.name,
          [Validators.required, Validators.minLength(2)],
        ],
        address: [
          this.initialData.address,
          [Validators.required, Validators.minLength(2)],
        ],
        phoneNumber: [this.initialData.phoneNumber, [Validators.required]],
        employeeNo: [this.initialData.employeeNo, [Validators.required]],
        startDate: [this.initialData.startDate, [Validators.required]],
        email: [
          this.initialData.email,
          [Validators.required, Validators.minLength(2)],
        ],
        position: [
          this.initialData.position,
          [Validators.required, Validators.minLength(2)],
        ],
        roleDescription: [
          this.initialData.roleDescription,
          [Validators.required, Validators.minLength(2)],
        ],
        hourlyRate: [this.initialData.hourlyRate, [Validators.required]],
        commissionPercentage: [
          this.initialData.commissionPercentage,
          // [Validators.required],
        ],
        customerExperienceBonus: [
          this.initialData.customerExperienceBonus,
          // [Validators.required],
        ],
        overnightAllowance: [
          this.initialData.overnightAllowance,
          // [Validators.required],
        ],
        targetOncentives: [
          this.initialData.targetOncentives,
          // [Validators.required],
        ],
        verbalWarnings: [
          this.initialData.verbalWarnings,
          // [Validators.required],
        ],
        writtenWarnings: [
          this.initialData.writtenWarnings,
          // [Validators.required],
        ],
      });
    });
  }

  get f() {
    return this.addInventoryForm.controls;
  }

  handleCloseModal() {
    this.bsModalRef.hide();
  }

  handleEditInventory() {
    this.submitted = true;

    if (this.addInventoryForm.valid && this.isLoading === false) {
      const formData = this.addInventoryForm.value;
      this.isLoading = true;

      this.api.updateData(this.initialData._id, formData).subscribe(
        (result: any) => {
          this.submitted = false;
          this.commonService.toast(result.message, "Success");

          this.isLoading = false;
          this.handleCloseModal();
        },
        (error: any) => {
          this.commonService.toast(error.error.message, "Error");
          this.isLoading = false;
        }
      );
    }
  }
}
